import { defineMessages } from "react-intl";
import { WebMessagePositionType as WebMessagePositionTypeProto } from "../../gen/witbooking/backoffice/webmessage/v1/webmessage_api_pb";
export enum WebMessagePositionType {
  INVALID_WEB_MESSAGE_POSITION_TYPE = "INVALID_WEB_MESSAGE_POSITION_TYPE",
  TOP_INVENTORY_STEP_1 = "TOP_INVENTORY_STEP_1",
  BELOW_LOGO_STEP_1 = "BELOW_LOGO_STEP_1",
  BELOW_PERSONAL_INFO_STEP_2 = "BELOW_PERSONAL_INFO_STEP_2",
  TOP_METHOD_PAYMENT_STEP_2 = "TOP_METHOD_PAYMENT_STEP_2",
  MODAL_STEP_1 = "MODAL_STEP_1",
  MODAL_STEP_2 = "MODAL_STEP_2",
  CONFIRMATION_PAGE = "CONFIRMATION_PAGE",
}
export const WebMessagePositionTypeMapping: Record<
  WebMessagePositionTypeProto,
  WebMessagePositionType
> = {
  [WebMessagePositionTypeProto.INVALID_WEB_MESSAGE_POSITION_TYPE]: WebMessagePositionType.TOP_INVENTORY_STEP_1,
  [WebMessagePositionTypeProto.TOP_INVENTORY_STEP_1]: WebMessagePositionType.TOP_INVENTORY_STEP_1,
  [WebMessagePositionTypeProto.BELOW_LOGO_STEP_1]: WebMessagePositionType.BELOW_LOGO_STEP_1,
  [WebMessagePositionTypeProto.BELOW_PERSONAL_INFO_STEP_2]:
    WebMessagePositionType.BELOW_PERSONAL_INFO_STEP_2,
  [WebMessagePositionTypeProto.TOP_METHOD_PAYMENT_STEP_2]:
    WebMessagePositionType.TOP_METHOD_PAYMENT_STEP_2,
  [WebMessagePositionTypeProto.MODAL_STEP_1]: WebMessagePositionType.MODAL_STEP_1,
  [WebMessagePositionTypeProto.MODAL_STEP_2]: WebMessagePositionType.MODAL_STEP_2,
  [WebMessagePositionTypeProto.CONFIRMATION_PAGE]: WebMessagePositionType.CONFIRMATION_PAGE,
};
export enum WebMessageType {
  INVALID_WEB_MESSAGE_TYPE = "INVALID_WEB_MESSAGE_TYPE",
  INFO = "INFO",
  NOTICE = "NOTICE",
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}

export const webMessageMessages = defineMessages({
  entityName: {
    id: "webMessage.entityName",
    defaultMessage: "Web Messages",
  },
  active: {
    id: "app.active",
    defaultMessage: "active",
  },
  validity: {
    id: "app.validity",
    defaultMessage: "validity",
  },
  validityError: {
    id: "app.entityForm.mustSetDateRange",
    defaultMessage: "mustSetDateRange",
  },
  type: {
    id: "app.type",
    defaultMessage: "type",
  },
  webMessagePositionType: {
    id: "webMessage.positionType",
    defaultMessage: "webMessagePositionType",
  },
  showOnlyOnUnavailable: {
    id: "webMessage.showOnlyOnUnavailable",
    defaultMessage: "showOnlyOnUnavailable",
  },
  unlockCode: {
    id: "webMessage.unlockCode",
    defaultMessage: "unlockCode",
  },
  webMessageTranslationsTitle: {
    id: "app.translations",
    defaultMessage: "translations",
  },
  webMessageTranslationsDescriptionLabel: {
    id: "webMessage.translations.description",
    defaultMessage: "Name",
  },
});

export const webMessagePositionTypeMessages = defineMessages({
  [WebMessagePositionType.INVALID_WEB_MESSAGE_POSITION_TYPE]: {
    id: "shared.webMessagePositionType.INVALID_WEB_MESSAGE_POSITION_TYPE",
    description: "invalid",
    defaultMessage: "invalid",
  },
  [WebMessagePositionType.TOP_INVENTORY_STEP_1]: {
    id: "shared.webMessagePositionType.TOP_INVENTORY_STEP_1",
    description: "invalid",
    defaultMessage: "invalid",
  },
  [WebMessagePositionType.BELOW_LOGO_STEP_1]: {
    id: "shared.webMessagePositionType.BELOW_LOGO_STEP_1",
    description: "invalid",
    defaultMessage: "invalid",
  },
  [WebMessagePositionType.BELOW_PERSONAL_INFO_STEP_2]: {
    id: "shared.webMessagePositionType.BELOW_PERSONAL_INFO_STEP_2",
    description: "invalid",
    defaultMessage: "invalid",
  },
  [WebMessagePositionType.TOP_METHOD_PAYMENT_STEP_2]: {
    id: "shared.webMessagePositionType.TOP_METHOD_PAYMENT_STEP_2",
    description: "invalid",
    defaultMessage: "invalid",
  },
  [WebMessagePositionType.MODAL_STEP_1]: {
    id: "shared.webMessagePositionType.MODAL_STEP_1",
    description: "invalid",
    defaultMessage: "invalid",
  },
  [WebMessagePositionType.MODAL_STEP_2]: {
    id: "shared.webMessagePositionType.MODAL_STEP_2",
    description: "invalid",
    defaultMessage: "invalid",
  },
  [WebMessagePositionType.CONFIRMATION_PAGE]: {
    id: "shared.webMessagePositionType.CONFIRMATION_PAGE",
    description: "invalid",
    defaultMessage: "invalid",
  },
});

export const webMessageTypeMessages = defineMessages({
  [WebMessageType.INVALID_WEB_MESSAGE_TYPE]: {
    id: "shared.webMessagePositionType.INVALID_WEB_MESSAGE_TYPE",
    description: "invalid",
    defaultMessage: "invalid",
  },
  [WebMessageType.INFO]: {
    id: "shared.webMessagePositionType.INVALID_WEB_MESSAGE_TYPE",
    description: "invalid",
    defaultMessage: "invalid",
  },
  [WebMessageType.NOTICE]: {
    id: "shared.webMessagePositionType.INVALID_WEB_MESSAGE_TYPE",
    description: "invalid",
    defaultMessage: "invalid",
  },
  [WebMessageType.ERROR]: {
    id: "shared.webMessagePositionType.INVALID_WEB_MESSAGE_TYPE",
    description: "invalid",
    defaultMessage: "invalid",
  },
  [WebMessageType.SUCCESS]: {
    id: "shared.webMessagePositionType.INVALID_WEB_MESSAGE_TYPE",
    description: "invalid",
    defaultMessage: "invalid",
  },
});

export const tableHeaderMessages = defineMessages({
  active: { id: "app.active", defaultMessage: "active" },
  translationsList: { id: "app.message", defaultMessage: "Message" },
  positionType: { id: "webMessage.positionType", defaultMessage: "positionType" },
  showOnlyOnUnavailable: {
    id: "webMessage.showWhenUnavailable",
    defaultMessage: "showWhenUnavailable",
  },
  bookingWindowPeriod: { id: "app.validity", defaultMessage: "Validity" },
});
